import { Pageable } from 'shared/table/models/Pageable';
import {
  Pagination,
  PaginationContainer,
  PaginationOptionsContainer,
} from './TablePagination.styles';
import { Icon, Select as OrbitaSelect } from '@orbita-ui/core';

const PAGE_SIZE_OPTIONS = [5, 10, 15, 20, 50, 100];

const buildPages = (totalPages: number, currentPage: number) => {
  if (totalPages < 5) {
    return new Array(totalPages).fill(0).map((_, idx) => idx + 1);
  }
  if (currentPage <= 3) {
    return new Array(5).fill(0).map((_, idx) => idx + 1);
  }
  if (totalPages - currentPage < 3) {
    return new Array(5).fill(0).map((_, idx) => idx + totalPages - 4);
  }
  return new Array(5).fill(0).map((_, idx) => idx + currentPage - 2);
};

const getPaginationData = (pageable: Pageable<any>) => {
  if (!pageable) {
    return {
      hasNext: false,
      hasPrev: false,
      currentPage: 0,
      pages: [],
      pageSize: 0,
      totalElements: 0,
    };
  }
  return {
    hasNext:
      pageable.page.totalPages !== 0 &&
      pageable.page.number !== pageable.page.totalPages - 1,
    hasPrev: pageable.page.number !== 0,
    currentPage: pageable.page.number + 1,
    pages: buildPages(pageable.page.totalPages, pageable.page.number + 1),
    pageSize: pageable.page.size,
    totalElements: pageable.page.totalElements,
  };
};

const page_size_options = PAGE_SIZE_OPTIONS.map((item) => ({
  label: `${item}`,
  value: `${item}`,
}));

export const TablePagination = (props: {
  pageable: Pageable<any>;
  onChangePaginationStatus: (status: { pageNumber: number; pageSize: number }) => void;
}) => {
  const { currentPage, hasNext, hasPrev, pages, pageSize, totalElements } =
    getPaginationData(props.pageable);

  const goToPage = (page: number) => {
    if (currentPage !== page) {
      changePageNumber(page);
    }
  };

  const nextPage = () => {
    if (hasNext) {
      changePageNumber(currentPage + 1);
    }
  };
  const prevPage = () => {
    if (hasPrev) {
      changePageNumber(currentPage - 1);
    }
  };

  const goToLastPage = () => {
    changePageNumber(props.pageable.page.totalPages);
  };

  const goToFirstPage = () => {
    changePageNumber(1);
  };

  const changePageNumber = (page: number) => {
    props.onChangePaginationStatus({
      pageNumber: page - 1,
      pageSize,
    });
  };
  const changePageSize = (pageSize: string) => {
    props.onChangePaginationStatus({
      pageNumber: 0,
      pageSize: Number(pageSize),
    });
  };

  return (
    <PaginationContainer>
      <PaginationOptionsContainer>
        <span>Resultados por página:</span>
        <OrbitaSelect
          defaultValue={'15'}
          onChange={(val) => changePageSize(val.target.value)}
          options={page_size_options}
          fullWidth
        />
      </PaginationOptionsContainer>
      <Pagination>
        <p>
          Resultados: {(currentPage - 1) * pageSize + 1} -{' '}
          {currentPage * pageSize > totalElements
            ? totalElements
            : currentPage * pageSize}{' '}
          de {totalElements}
        </p>
        <div>
          <button disabled={!hasPrev} onClick={goToFirstPage}>
            <Icon name="ChevronsLeftIcon" />
          </button>
          <button disabled={!hasPrev} onClick={prevPage}>
            <Icon name="ChevronLeftSmallIcon" />
          </button>
          {pages.map((item) => (
            <button
              key={'pagina-' + item}
              onClick={() => goToPage(item)}
              className={currentPage === item ? 'active' : ''}
            >
              <span>{item}</span>
            </button>
          ))}
          <button disabled={!hasNext} onClick={nextPage}>
            <Icon name="ChevronRightSmallIcon" />
          </button>
          <button disabled={!hasNext} onClick={goToLastPage}>
            <Icon name="ChevronsRightIcon" />
          </button>
        </div>
      </Pagination>
    </PaginationContainer>
  );
};
